var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inoutboard"},[_c('v-container',[_c('h2',[_vm._v("This is in out board page.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }